import type { UpdateOrganizationUserInput } from "@api/rest/types-and-hooks";

// The same pair a provider edits on the portal's /settings/signature page. Derived from the
// generated input so a backend rename fails tsc instead of the API silently dropping the old key.
export type ProviderProfileValues = Required<
  Pick<UpdateOrganizationUserInput, "professional_title" | "license_number">
>;

export const PROVIDER_PROFILE_FIELDS: { key: keyof ProviderProfileValues; label: string; placeholder?: string }[] = [
  { key: "professional_title", label: "Professional Title", placeholder: "e.g. Lead BCBA" },
  { key: "license_number", label: "License / Certification #" },
];

// The API trims surrounding whitespace before saving, so compare and send what it would store.
const normalize = (value: string | undefined) => (value ?? "").trim();

/** The one "changed" rule, shared by the edit highlight and the payload so they can't disagree. */
export const isProviderProfileFieldChanged = (value: string | undefined, original: string) =>
  normalize(value) !== normalize(original);

/** Only the fields that differ from `original`, so an untouched field is never re-sent over a provider's own edit. */
export const changedProviderProfileFields = (
  values: Partial<ProviderProfileValues>,
  original: ProviderProfileValues,
): Partial<ProviderProfileValues> =>
  Object.fromEntries(
    PROVIDER_PROFILE_FIELDS.filter(({ key }) => isProviderProfileFieldChanged(values[key], original[key])).map(
      ({ key }) => [key, normalize(values[key])],
    ),
  );
